
export const decodeHtmlEntities = (text) => {
    if (!text) return '';
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text
      .replace(/\\&/g, '&')
      .replace(/\\'/g, "'")
      .replace(/\\"/g, '"')
      .replace(/\\>/g, '>')
      .replace(/\\</g, '<')
      .replace(/\\\\/g, '\\');
    return textarea.value;
  };
  
export const encodeHtmlEntities = (text) => {
    if (!text) return '';
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };